exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "td[data-v-38dae56e],th[data-v-38dae56e]{width:110px;max-width:110px;min-width:110px}.bar[data-v-38dae56e]{background:-webkit-gradient(linear,left top,right top,from(#ef565b),to(#512e6f));background:linear-gradient(90deg,#ef565b,#512e6f);height:20px;width:20px;border-radius:9px}.spb[data-v-38dae56e]{padding:4px 5px;color:#fff;font-size:.7em}.position-no[data-v-38dae56e]{position:absolute;top:0;right:0;z-index:-1}", ""]);

// exports
